import React from 'react';
import { Container, Paragraph } from '../style';

const Footer = () => {
    return (
        <>
            <Container>
                <Paragraph center>
                    ©2021 Ahmad Alfan
                    <br />
                    PLM-BDO, ID
                </Paragraph>
            </Container>
        </>
    );
};

export default Footer;
